import { coreInstance, konjInstance } from "api";
import { PAGE_SIZE_LARGE } from "utils/Constans";

const getKonjSchoolList = async () => {
  const { data } = await konjInstance.get(`/classroom/get-own-school/`);
  return data.results;
};
const getKonjClassBaseList = async ({ school_id }) => {
  const { data } = await konjInstance.get(`/classroom/list-create-grade/`, {
    params: {
      school_id,
      "page-size": PAGE_SIZE_LARGE,
    },
  });
  return data.results;
};
const getKonjClassList = async ({ school_id, grade_id }) => {
  const { data } = await konjInstance.get(`/classroom/get-own-class/`, {
    params: {
      school_id,
      grade_id,
      "page-size": PAGE_SIZE_LARGE,
    },
  });
  return data.results;
};
const getKonjClassMembers = async ({ class_id, role }) => {
  const { data } = await konjInstance.get(
    `classroom/get-class-member/${class_id}/`,
    {
      params: {
        role,
        "page-size": PAGE_SIZE_LARGE,
      },
    }
  );
  return data.results;
};

const getClassBaseList = async ({ schoolId, semesterId }) => {
  const { data } = await coreInstance.get(
    `/api/teacher/v1/ClassBase/GetBySchool/${schoolId}/${semesterId}`
  );
  return data.data;
};

const getClassList = async ({ schoolId, semesterId, classBaseIds = [] }) => {
  const { data } = await coreInstance.post(
    `/api/teacher/v1/SchoolClass/GetByClassBase/${schoolId}/${semesterId}`,
    classBaseIds
  );
  return data.data;
};

const getCourseList = async ({ schoolId, semesterId, classListId = [] }) => {
  const { data } = await coreInstance.post(
    `/api/teacher/v1/Course/GetByClass/${schoolId}/${semesterId}`,
    classListId
  );
  return data.data;
};

const getStudentList = async ({ schoolId, semesterId, currentClassID }) => {
  const { data } = await coreInstance.get(
    `/api/teacher/v1/Student/${schoolId}/${semesterId}/${currentClassID}`
  );
  return data.data;
};

const getTeacherList = async ({ schoolId, semesterId, currentClassID }) => {
  const { data } = await coreInstance.get(
    `/api/teacher/v1/user/GetTeachers/${schoolId}/${semesterId}/${currentClassID}`
  );
  return data.data;
};
const getPersonalList = async ({ schoolId, semesterId }) => {
  const { data } = await coreInstance.get(
    `/api/teacher/v1/user/GetPersonals/${schoolId}/${semesterId}`
  );
  return data.data;
};
const getSchoolStatus = async ({ filterType }) => {
  const { data } = await coreInstance.get(
    `/api/common/v1/SchoolStatus?${filterType ? `status=${filterType}` : ""}`
  );
  return data.data;
};

const getUpdateStatus = async ({ schoolId, semesterId, status }) => {
  const { data } = await coreInstance.get(
    `/api/common/v1/SchoolStatus/UpdateStatus/${schoolId}/${semesterId}`,
    {
      params: {
        status,
      },
    }
  );
  return data.data;
};
const postConfirmStatus = async ({ schoolId, semesterId, body }) => {
  const { data } = await coreInstance.post(
    `/api/common/v1/SchoolStatus/ConfirmStatus/${schoolId}/${semesterId}`,
    body
  );
  return data.data;
};

export {
  getClassBaseList,
  getPersonalList,
  getClassList,
  getStudentList,
  getKonjSchoolList,
  getKonjClassBaseList,
  getKonjClassList,
  getKonjClassMembers,
  getTeacherList,
  getCourseList,
  getSchoolStatus,
  getUpdateStatus,
  postConfirmStatus,
};
